import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideSnackbar } from "../../redux/slices/snackbarSlice";
import SnackBar from "./SnackBar.component";

const SnackBarContainer = () => {
  const { message, type, isSnackBarVisible } = useSelector(
    (state) => state.snackbar
  );
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(hideSnackbar());
  };

  useEffect(() => {
    if (isSnackBarVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSnackBarVisible]);

  if (!isSnackBarVisible) {
    return null;
  }

  const containerProps = {
    message,
    type,
  };
  const containerMethods = {
    onClose,
  };
  return (
    <SnackBar
      containerProps={containerProps}
      containerMethods={containerMethods}
    />
  );
};

export default SnackBarContainer;
